import React, { useState, useEffect } from 'react';
import HeroSectionForm from './HeroSectionForm';
import QuickLinksForm from './QuicklinksForm';
import HighlightsForm from './HighlightsForm';
import NewsForm from './NewsForm';
import CountdownForm from './CountdownForm';
import { 
  Video, 
  Link2, 
  Sparkles, 
  Newspaper, 
  Timer
} from 'lucide-react';
import './FormsUnified.css';

export default function HomepageFormV2({ apiBase, activeTab }) {
  const [currentSection, setCurrentSection] = useState('hero');

  useEffect(() => {
    if (activeTab === 'cms-hero' || activeTab === 'hero') {
      setCurrentSection('hero');
    } else if (activeTab === 'cms-quicklinks' || activeTab === 'quicklinks' || activeTab === 'quick_links') {
      setCurrentSection('quicklinks');
    } else if (activeTab === 'cms-highlights' || activeTab === 'highlights') {
      setCurrentSection('highlights');
    } else if (activeTab === 'cms-news' || activeTab === 'news') {
      setCurrentSection('news');
    } else if (activeTab === 'cms-countdown' || activeTab === 'countdown') {
      setCurrentSection('countdown');
    }
  }, [activeTab]);

  return (
    <div className="unified-master-container">
      {/* Tab Navigation Pill Bar */}
      <div className="unified-tab-bar">
        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'hero' ? 'active' : ''}`}
          onClick={() => setCurrentSection('hero')}
        >
          <Video className="w-4 h-4 mr-2" />
          <span>Hero Banner</span>
        </button>

        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'quicklinks' ? 'active' : ''}`}
          onClick={() => setCurrentSection('quicklinks')}
        >
          <Link2 className="w-4 h-4 mr-2" />
          <span>Quick Links</span>
        </button>

        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'highlights' ? 'active' : ''}`}
          onClick={() => setCurrentSection('highlights')}
        >
          <Sparkles className="w-4 h-4 mr-2" />
          <span>Highlights</span>
        </button>

        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'news' ? 'active' : ''}`}
          onClick={() => setCurrentSection('news')}
        >
          <Newspaper className="w-4 h-4 mr-2" />
          <span>News & Events</span>
        </button>

        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'countdown' ? 'active' : ''}`}
          onClick={() => setCurrentSection('countdown')}
        >
          <Timer className="w-4 h-4 mr-2" />
          <span>Countdown</span>
        </button>
      </div>

      {/* Render Active Section Form */}
      <div className="unified-tab-content">
        {currentSection === 'hero' && <HeroSectionForm apiBase={apiBase} />}
        {currentSection === 'quicklinks' && <QuickLinksForm apiBase={apiBase} />}
        {currentSection === 'highlights' && <HighlightsForm apiBase={apiBase} />}
        {currentSection === 'news' && <NewsForm apiBase={apiBase} />}
        {currentSection === 'countdown' && <CountdownForm apiBase={apiBase} />}
      </div>
    </div>
  );
}
